import type { ProductLogoSmallProps } from '../types';

export function ProductLogoSmallAccesses({
  size = 20,
  color = '#1874A1',
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 480 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M396 48C409.255 48 420 58.7452 420 72V84L60 84V72C60 58.7452 70.7452 48 84 48L396 48Z"
        fill={color}
      />
      <path
        d="M84 432C70.7452 432 60 421.255 60 408V396L420 396V408C420 421.255 409.255 432 396 432L84 432Z"
        fill={color}
      />
      <path d="M420 84V396L384 396L384 84L420 84Z" fill={color} />
      <path
        d="M96 84L96 156C96 162.627 90.6274 168 84 168H72C65.3726 168 60 162.627 60 156L60 84L96 84Z"
        fill={color}
      />
      <path
        d="M60 396V324C60 317.373 65.3726 312 72 312H84C90.6274 312 96 317.373 96 324V396H60Z"
        fill={color}
      />
      <path
        d="M288 192C294.627 192 300 197.373 300 204V276C300 282.627 294.627 288 288 288L48 288C41.3726 288 36 282.627 36 276L36 204C36 197.373 41.3726 192 48 192L288 192Z"
        fill={color}
      />
      <path
        d="M241.451 343.931L340.931 244.451C344.055 241.327 344.055 236.261 340.931 233.137L241.451 133.657C236.411 128.617 227.794 132.186 227.794 139.314V338.274C227.794 345.401 236.411 348.971 241.451 343.931Z"
        fill={color}
      />
    </svg>
  );
}
